import { render, staticRenderFns } from "./NvLabel.vue?vue&type=template&id=26b6dfc2&scoped=true&"
import script from "./NvLabel.vue?vue&type=script&lang=js&"
export * from "./NvLabel.vue?vue&type=script&lang=js&"
import style0 from "./NvLabel.vue?vue&type=style&index=0&id=26b6dfc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6dfc2",
  null
  
)

export default component.exports